
























































































































































import { Component } from 'vue-property-decorator'
import {
  $leadMails,
  $newObj,
  CustomerLeadMailModel,
  CustomerLeadSearchQuery,
  CustomerLeadStatuses,
  ICustomerLeadMailModel,
  IEntitySearchResultOfCustomerLeadLightModel,
  LeadMailLanguage,
  SearchQueryRangeOfDateTime
} from '@immosparrow/cockpit-api-v2'
import LeadItem from './LeadItem.vue'
import Mapbox from '@/components/map/Mapbox.vue'
import AgentCard from './right/AgentCard.vue'
import GlobalMixin from '../../mixins/GlobalMixin'
import { mixins } from 'vue-class-component'
import InfiniteLoading from 'vue-infinite-loading'

interface CustomerLeadsFilter {
  value: CustomerLeadStatuses;
  text: string;
  icon: boolean;
}

interface RangeFilter {
  start: Date | null;
  end: Date | null;
}

@Component({
  components: {
    LeadItem,
    Mapbox,
    AgentCard
  }
})
export default class Main extends mixins(GlobalMixin) {
  $refs = {
    infiniteLoading: InfiniteLoading as any
  };

  tabList = true
  dataLoaded = false
  fetchingMapData = false
  page = 0
  pageSize = 5
  agentCardVisible = false
  infiniteId = +new Date()
  leads: IEntitySearchResultOfCustomerLeadLightModel = { items: [] }
  mapLeads: IEntitySearchResultOfCustomerLeadLightModel = { items: [] }
  filters: CustomerLeadsFilter[] = [
    { value: CustomerLeadStatuses.Liked, text: 'Liked', icon: true },
    { value: CustomerLeadStatuses.NoFeedback, text: 'No Feeedback', icon: false },
    { value: CustomerLeadStatuses.Disliked, text: 'Disliked', icon: true },
    { value: CustomerLeadStatuses.New, text: 'New', icon: false },
    { value: CustomerLeadStatuses.Viewed, text: 'Viewed', icon: false }
  ]

  leadFilters: CustomerLeadsFilter[] = []
  hasLeadFilters = false
  totalCount = 0
  currentCount = 0
  mailInfo: ICustomerLeadMailModel = $newObj(CustomerLeadMailModel)
  rangeFilter: RangeFilter | null = {
    start: null,
    end: null
  }

  windowWidth = 0

  toggleAgentCard () {
    this.agentCardVisible = !this.agentCardVisible
  }

  get leadId () {
    return this.$route.query?.leadId as string
  }

  get sortedFilters () {
    return this.filters.sort((a, b) => a.value - b.value)
  }

  get allLeads () {
    return this.leads.items || []
  }

  get isMobile () {
    return this.windowWidth <= 992
  }

  created () {
    const self = this
    this.$root.$on('updateLeadStatus', (id: string, status: boolean) => {
      if (this.removeLead(status)) {
        const leadInd = self.allLeads.findIndex(item => item.id === id)
        const lngth = self.allLeads.length
        if (leadInd !== -1 && self.leads.items) {
          self.leads.items.splice(leadInd, 1)
          if (lngth < 3 && !this.dataLoaded) {
            self.$nextTick(() => {
              self.getLeads(undefined)
            })
          }
          if (!lngth) {
            self.$refs['infiniteLoading']['stateChanger'].error()
          }
        }
      }
    })
    if (this.leadId) this.getLeadById()
    this.handleWindowSize()
    window.addEventListener('resize', this.handleWindowSize)
  }

  beforeDestroy () {
    this.$root.$off('updateLeadStatus')
    window.removeEventListener('resize', this.handleWindowSize)
  }

  async getLeadById () {
    const lead = await this.$store.dispatch('getLeadById', this.leadId)
    if (lead) {
      this.$bvModal.show('modal-1')
      const self = this
      this.$nextTick(async () => {
        if (!lead.customerViewedTime) {
          lead.customerViewedTime = new Date()
          await this.$store.dispatch('updateViewedStatus', lead.id)
          if (self.leads.items) {
            const foundLead = self.leads.items.findIndex(item => item.id === lead.id)
            if (foundLead !== -1) {
              self.leads.items[foundLead] = lead
              this.$forceUpdate()
            }
          }
        }
      })
    }
  }

  async getLeads ($state: any) {
    if (!this.id) {
      return $state.complete()
    }

    const query = $newObj(CustomerLeadSearchQuery)

    query.page = this.page
    query.pageSize = this.pageSize
    query.customerLeadStatus = 0

    if (this.leadFilters.length) {
      this.hasLeadFilters = true
      this.leadFilters.forEach((filter) => {
        if (query.customerLeadStatus !== undefined) {
          query.customerLeadStatus |= filter.value
        }
      })
    } else {
      query.customerLeadStatus = CustomerLeadStatuses.All
    }

    query.sentTime = undefined

    if (this.rangeFilter?.start && this.rangeFilter?.end) {
      query.sentTime = $newObj(SearchQueryRangeOfDateTime)
      query.sentTime.min = this.rangeFilter.start
      query.sentTime.max = this.rangeFilter.end
      query.sentTime.min.setHours(0, 0, 0)
      query.sentTime.max.setHours(23, 59, 59)
    }

    const res: IEntitySearchResultOfCustomerLeadLightModel = await this.$store.dispatch('loadLeads', { id: this.id, query: query })

    if (res) {
      this.totalCount = res?.entityCounts?.totalCount || 0

      if (res?.items?.length) {
        const mailId = res.items[0].mailId
        if (mailId) {
          this.loadMailInfo(mailId)
        }
        this.page += 1
        if (!this.leads.items) {
          this.leads.items = []
        }
        res.items.forEach(el => this.leads.items?.push(el))
        this.dataLoaded = true
        if ($state) {
          $state.loaded()
        }
      } else if ($state) {
        if (this.leads.items?.length) $state.loaded()
        $state.complete()
      }

      this.currentCount = this.leads?.items?.length || 0

      if (!this.mapLeads.items?.length && !this.fetchingMapData) {
        const mapQuery = $newObj(CustomerLeadSearchQuery)
        mapQuery.maxItemCount = 100
        this.fetchingMapData = true
        this.mapLeads = await $leadMails.findLeads(this.id, mapQuery) || { items: [] }
        this.fetchingMapData = false
      }
    } else {
      this.$router.push({ name: 'NotFound' })
    }
  }

  async loadMailInfo (mailId: string) {
    if (!this.$store.getters.lastMailInfo) {
      const mailInfo: CustomerLeadMailModel[] = await $leadMails.getMailInfoMultiple([mailId]) || []
      this.$store.commit('setLastMailInfo', mailInfo)
      if (mailInfo.length) {
        this.setLanguage(mailInfo[0].language)
      }
    }
  }

  setLanguage (lang: LeadMailLanguage = LeadMailLanguage.En) {
    let language = ''
    switch (lang) {
      case LeadMailLanguage.De:
        language = 'de'
        break
      case LeadMailLanguage.It:
        language = 'it-CH'
        break
      case LeadMailLanguage.Fr:
        language = 'fr'
        break
      default:
        language = 'en'
        break
    }
    this.$store.commit('setLanguage', language)
  }

  handleWindowSize () {
    this.windowWidth = window.innerWidth
  }

  switchTab (state: boolean) {
    if (this.dataLoaded) this.tabList = state
  }

  resetList () {
    this.page = 0
    if (this.leads.items && this.leads.items.length > 0) {
      this.leads.items = []
    }
    this.infiniteId += 1
    this.dataLoaded = false
  }

  updateLeadStatus (id: string) {
    const item = this.leads?.items?.find(item => item.id === id)
    if (item && this.leads?.items) {
      this.leads.items.splice(this.leads.items.indexOf(item), 1)
    }
  }

  selectFilter (el: CustomerLeadsFilter) {
    if (!this.leadFilters.find(f => f.value === el.value)) {
      this.leadFilters.push(el)
      this.filters = this.filters.filter(f => f.value !== el.value)
      this.resetList()

      this.dataLoaded = false
    }
  }

  removeFilter (el: CustomerLeadsFilter, index: number) {
    this.filters.unshift(this.leadFilters[index])
    const filters = this.leadFilters
    filters.splice(index, 1)
    this.leadFilters = filters
    this.resetList()
  }

  removeLead (status: boolean) {
    if (this.leadFilters.length) {
      if (this.leadFilters.find(item => item.value === CustomerLeadStatuses.Liked) && !status) return true
      if (this.leadFilters.find(item => item.value === CustomerLeadStatuses.Disliked) && status) return true
      if (this.leadFilters.find(item => item.value === CustomerLeadStatuses.NoFeedback || item.value === CustomerLeadStatuses.New)) return true
    }
    return false
  }

  clearRange () {
    if (!this.rangeFilter) return
    this.rangeFilter = null
    this.resetList()
  }

  updateMapLeads (leads: IEntitySearchResultOfCustomerLeadLightModel) {
    this.mapLeads = leads
    this.dataLoaded = true
  }
}
